import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { IconTypographyContainer } from 'reservations/base/components/IconTypography';
import { navigateToRoute } from 'reservations/base/helpers/routes';
import { useNumberOfGuests } from 'reservations/booking/providers/BookingProvider';
import {
  EvenSplitIconTypography,
  PrivatePaymentIconTypography
} from 'reservations/checklessPayments/components/SplitBillIconTypography';
import { useGuestInviteSMSFields } from 'reservations/guests/hooks/useGuestInviteSMSFields';

export const InviteToSplitModal = () => {
  const numberOfGuests = useNumberOfGuests();

  const header = `Invite ${numberOfGuests > 2 ? 'guests' : 'a guest'} to split the bill`;
  const subheader = `${numberOfGuests > 2 ? 'You may select some or all of your guests to split the bill with you. ' : ''}By inviting them to split, you will send them a link to join the reservation and save their card with Checkless Payments.`;

  const { title, text, url } = useGuestInviteSMSFields({
    inviteToSplit: true
  });
  const smsMessage = encodeURIComponent(`${text} ${url}`);

  const onClick = async () => {
    if (navigator.canShare && navigator.canShare({ title, text, url })) {
      await navigator.share({ title, text, url });
    } else {
      navigateToRoute(`sms://?body=${smsMessage}`);
    }
  };

  return (
    <BaseDrawer
      dataTestId="invite-to-split-modal"
      header={header}
      subheader={subheader}
      primaryButton={{
        label: 'INVITE TO SPLIT',
        onClick: onClick
      }}
    >
      <IconTypographyContainer>
        <EvenSplitIconTypography />
        <PrivatePaymentIconTypography />
      </IconTypographyContainer>
    </BaseDrawer>
  );
};
